"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
require("../Styles/ActionButton.css");
var Types_1 = require("../Types");
var ActionButtons = {};
ActionButtons[Types_1.PackAction.Verify.value] = free_solid_svg_icons_1.faQuestion;
ActionButtons[Types_1.PackAction.Supply.value] = free_solid_svg_icons_1.faShare;
ActionButtons[Types_1.PackAction.MarkAsLocked.value] = free_solid_svg_icons_1.faLock;
ActionButtons[Types_1.PackAction.ExportFromEU.value] = free_solid_svg_icons_1.faShare;
ActionButtons[Types_1.PackAction.MarkAsSample.value] = free_solid_svg_icons_1.faFlask;
ActionButtons[Types_1.PackAction.MarkAsFreeSample.value] = free_solid_svg_icons_1.faFlask;
ActionButtons[Types_1.PackAction.MarkAsStolen.value] = free_solid_svg_icons_1.faUserSecret;
ActionButtons[Types_1.PackAction.MarkAsDestroyed.value] = free_solid_svg_icons_1.faTrash;
ActionButtons[Types_1.PackAction.Reintroduce.value] = free_solid_svg_icons_1.faReply;
ActionButtons[Types_1.PackAction.UndoMarkAsLocked.value] = free_solid_svg_icons_1.faReply;
ActionButtons[Types_1.PackAction.UndoExportFromEU.value] = free_solid_svg_icons_1.faReply;
ActionButtons[Types_1.PackAction.UndoMarkAsSample.value] = free_solid_svg_icons_1.faReply;
ActionButtons[Types_1.PackAction.UndoMarkAsFreeSample.value] = free_solid_svg_icons_1.faReply;
ActionButtons[Types_1.PackAction.UndoMarkAsStolen.value] = free_solid_svg_icons_1.faReply;
ActionButtons[Types_1.PackAction.UndoMarkAsDestroyed.value] = free_solid_svg_icons_1.faReply;
ActionButtons[Types_1.ReportsAction.History({}).value] = free_solid_svg_icons_1.faHistory;
ActionButtons[Types_1.ReportsAction.RequestLookup({}).value] = free_solid_svg_icons_1.faSearch;
var ActionButton = /** @class */ (function (_super) {
    __extends(ActionButton, _super);
    function ActionButton(props) {
        var _this = _super.call(this, props) || this;
        _this.self = React.createRef();
        return _this;
    }
    ActionButton.prototype.render = function () {
        var _this = this;
        return (React.createElement(reactstrap_1.Button, { className: "action-button my-2 w-100", outline: !this.props.active, color: "primary", disabled: this.props.disabled, onClick: function () { var _a; _this.props.onClick(); (_a = _this.self.current) === null || _a === void 0 ? void 0 : _a.blur(); }, innerRef: this.self },
            React.createElement("div", { className: "action-button-text" }, this.props.action.displayName),
            React.createElement("div", { className: "action-button-icon" },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ActionButtons[this.props.action.value] }))));
    };
    return ActionButton;
}(React.Component));
exports.ActionButton = ActionButton;
//# sourceMappingURL=ActionButton.js.map